import axios from 'axios';
import host from '../global';

const getAuthHeader = () => ({
  Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
});

export const fetchDashboardStatsService = async () => {
  const response = await axios.get(`${host}/api/orgadmin/dashboard-stats`, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const fetchSubscriptionUsageService = async (org_id) => {
  const response = await axios.get(`${host}/get_subscription_usage`, {
    headers: getAuthHeader(),
    params: { org_id },
  });
  return response.data;
};
